// extracted by mini-css-extract-plugin
module.exports = {"container":"BubbleIcon_container__IR35x","icon":"BubbleIcon_icon__2CUmO"};